import { c as _c } from "react/compiler-runtime";
import { useQueryState } from "nuqs";
import { QUERY_PARAM_KEYS } from "./keys";
export function useCurrencyCategoryQueryParam() {
  const $ = _c(5);
  const [category, setCategory] = useQueryState(QUERY_PARAM_KEYS.currencyCategory);
  let t0;
  if ($[0] !== setCategory) {
    t0 = async function onSelectCategory(value) {
      await setCategory(value);
    };
    $[0] = setCategory;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const onSelectCategory = t0;
  const t1 = category ? decodeURIComponent(category) : undefined;
  let t2;
  if ($[2] !== onSelectCategory || $[3] !== t1) {
    t2 = {
      category: t1,
      onSelectCategory
    };
    $[2] = onSelectCategory;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}